import React from 'react';
import { breakpoints, colors } from '../config';

const InfoText = ({ children, ...rest }) => {
  const Icon = () => (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 .672c-.917 0-1.781.172-2.594.515a6.836 6.836 0 0 0-2.125 1.438A6.666 6.666 0 0 0 .86 4.735a6.42 6.42 0 0 0-.53 2.593c0 .927.176 1.792.53 2.594a6.62 6.62 0 0 0 1.422 2.125 6.622 6.622 0 0 0 2.125 1.422A6.421 6.421 0 0 0 7 14c.917 0 1.781-.177 2.594-.531a6.623 6.623 0 0 0 2.125-1.422 6.62 6.62 0 0 0 1.422-2.125 6.348 6.348 0 0 0 .53-2.594 6.42 6.42 0 0 0-.53-2.594 6.666 6.666 0 0 0-1.422-2.109 6.837 6.837 0 0 0-2.125-1.438A6.588 6.588 0 0 0 7 .672Zm.813 8.906.25.172c-.188.27-.355.5-.5.688a4.754 4.754 0 0 1-.36.421 2.014 2.014 0 0 1-.516.36c-.166.073-.343.11-.53.11a.931.931 0 0 1-.578-.188.586.586 0 0 1-.188-.235.962.962 0 0 1-.063-.36c0-.04.005-.098.016-.171.01-.083.031-.172.062-.266.01-.062.026-.13.047-.203.021-.083.042-.172.063-.265l.828-2.594v-.031a.139.139 0 0 0 .015-.063c.01-.01.016-.02.016-.031v-.047a.358.358 0 0 0-.047-.188.143.143 0 0 0-.11-.093.647.647 0 0 0-.202-.047 7.23 7.23 0 0 0-.329-.031v-.297c.115-.01.25-.021.407-.032.156-.02.338-.041.547-.062A36.058 36.058 0 0 1 7.5 6l.5-.094-1.016 3.282a5.808 5.808 0 0 1-.093.359c-.021.094-.037.167-.047.219-.042.135-.073.25-.094.343a2.08 2.08 0 0 0-.016.204c0 .041.006.078.016.109.01.02.026.036.047.047.02.01.036.02.047.031h.078c.052 0 .114-.02.187-.063.073-.052.151-.13.235-.234a2.22 2.22 0 0 0 .25-.297c.073-.104.146-.213.218-.328Zm.515-5.406c0 .229-.083.427-.25.594A.785.785 0 0 1 7.5 5a.839.839 0 0 1-.594-.234.839.839 0 0 1-.234-.594c0-.23.078-.427.234-.594a.811.811 0 0 1 .594-.25c.23 0 .422.083.578.25.167.167.25.365.25.594Z"
        fill="#007AB7"
      />

      <style jsx>{`
        svg {
          margin-right: 5px;
        }
      `}</style>
    </svg>
  );

  return (
    <p {...rest}>
      <Icon />
      {children}

      <style jsx>{`
      p {
        font-family: ${colors.baseFontDisplay};
        font-size: 12px;
        line-height: 18px;
        margin-top: 0;
        margin-bottom: 15px;
        color: #56504C;
        display: flex;
      }

      @media screen and (min-width: ${breakpoints.md}) {
        /*h3 {
          font-family: ${colors.baseFontDisplay};
        }*/
      }
    `}</style>
    </p>
  );
};

export default InfoText;
